<script setup lang="ts">
import SettingsOrgTeamModal from '~/components/settings/org/TeamModal.vue'

const modalOpen = defineModel<boolean>({ required: true })
</script>

<template>
  <SettingsOrgTeamModal v-model="modalOpen" mode="create" />
</template>
